import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  media: {
    borderRadius: "20px",
    objectFit: "cover",
    width: "100%",
    maxHeight: "600px",
  },
  card: {
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      flexDirection: "column",
    },
  },
  section: {
    borderRadius: "20px",
    // backgroundColor: '#FCB134',
    margin: "10px",
    padding: "15px",
    flex: 1,
  },
  p: {
    color: "#7AA0C2",
  },
  cardSection: {
    marginLeft: "10px",
    backgroundColor: "#181E2B",
    // backgroundColor: '#7A235B',
    width: "75%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      width: "100%",
      height: "120px",
    },
  },
  messageText: {
    // paddingLeft: "30px",
    margin: "28px",
  },
  imageSection: {
    marginLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  recommendedPosts: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  loadingPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    borderRadius: "15px",
    height: "39vh",
  },
  categoryChipStyle: {
    // display: "flex",
    justifyContent: "flex-start",
    // flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));
